import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { AdminPlanOption } from '@services/admin-users.service';

interface AdminChangePlanModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (planId: number) => Promise<void>;
  plans: AdminPlanOption[];
  currentPlanCode?: string | null;
  userName: string;
}

export const AdminChangePlanModal: React.FC<AdminChangePlanModalProps> = ({
  open,
  onClose,
  onSave,
  plans,
  currentPlanCode,
  userName,
}) => {
  const currentPlan = plans.find((p) => p.code === currentPlanCode);
  const [selectedPlanId, setSelectedPlanId] = useState<number | ''>('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setSelectedPlanId(currentPlan?.value ?? (plans[0]?.value ?? ''));
    }
  }, [open, currentPlan, plans]);

  const handleSave = async () => {
    if (!selectedPlanId) return;
    setSaving(true);
    try {
      await onSave(selectedPlanId as number);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Змінити тарифний план</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {userName}
        </Typography>
        <FormControl fullWidth>
          <InputLabel>Тарифний план</InputLabel>
          <Select
            value={selectedPlanId}
            label="Тарифний план"
            onChange={(e) => setSelectedPlanId(e.target.value as number)}
          >
            {plans.map((plan) => (
              <MenuItem key={plan.value} value={plan.value}>
                {plan.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Скасувати
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving || !selectedPlanId}
          startIcon={saving ? <CircularProgress size={16} /> : undefined}
        >
          Зберегти
        </Button>
      </DialogActions>
    </Dialog>
  );
};
